// extracted by mini-css-extract-plugin
export default {"menuButton":"LanguageSelector_menuButton__pyyMn","header":"LanguageSelector_header__i3Kt3","icon":"LanguageSelector_icon__-ZaDJ"};